import { SensorPortCommunicationMode } from "../../../portConfigs.js";
import { OUTPUT_OPERATING_MODE_RANGE } from "../../outputOperatingMode.js";
import { OUTPUT_POSITION_RANGE } from "../../outputPosition.js";
import { SOLENOID_VERIFICATION_RESULT_RANGE } from "../../solenoidVerification.js";
import { SensorClusterConfig } from "../types.js";

function makeSolenoidVerificationCluster(
    friendlyName: string,
    elementKey: "solenoidVerification" | "saplingVerification",
): SensorClusterConfig<Record<string, never>> {
    return {
        communicationMode: SensorPortCommunicationMode.DIGITAL,
        requiredSubChannels: [],
        optionalSubChannels: [],
        isPermanentlyAttached: true,
        parameterConfigs: {},
        manufacturerName: "Verdi",
        modelName: "Solenoid Verification",
        friendlyName,
        friendlyShortName: "Solenoid",
        generateSensorElements: () => [
            {
                sensorElementConfigKey: elementKey,
                parameters: {},
                legalConvertedRange: [null, null],
                subChannel: 0,
            },
        ],
    };
}

const lastErrorCodeBase: Omit<SensorClusterConfig<Record<string, never>>, "generateSensorElements"> = {
    communicationMode: SensorPortCommunicationMode.DIGITAL,
    requiredSubChannels: [],
    optionalSubChannels: [],
    isPermanentlyAttached: true,
    parameterConfigs: {},
    manufacturerName: "Verdi",
    modelName: "Last Error Code",
    friendlyName: "Last Error Code",
    friendlyShortName: "Error",
};

export const solenoidClusterConfigs: Record<string, SensorClusterConfig<Record<string, never>>> = {
    /**
     * A Gen 4 device output. Same sub-channel layout as the generation-agnostic `Output` cluster, plus
     * solenoid verification on sub-channel 1, which only Gen 4 reports.
     */
    Gen4_Output: {
        communicationMode: SensorPortCommunicationMode.DIGITAL,
        requiredSubChannels: [],
        optionalSubChannels: [],
        isPermanentlyAttached: true,
        parameterConfigs: {},
        manufacturerName: "Verdi",
        modelName: "Output State & Solenoid Verification",
        friendlyName: "Output & Solenoid",
        friendlyShortName: "Output",
        generateSensorElements: () => [
            {
                sensorElementConfigKey: "outputPosition",
                parameters: {},
                legalConvertedRange: OUTPUT_POSITION_RANGE,
                subChannel: 0,
            },
            {
                sensorElementConfigKey: "solenoidVerification",
                parameters: {},
                legalConvertedRange: SOLENOID_VERIFICATION_RESULT_RANGE,
                subChannel: 1,
            },
            {
                sensorElementConfigKey: "outputOperatingMode",
                parameters: {},
                legalConvertedRange: OUTPUT_OPERATING_MODE_RANGE,
                subChannel: 2,
            },
        ],
    },

    SeedSap_SaplingVerification: makeSolenoidVerificationCluster(
        "Sapling Solenoid Verification",
        "saplingVerification",
    ),

    Gen4_LastErrorCode: {
        ...lastErrorCodeBase,
        generateSensorElements: () => [
            {
                sensorElementConfigKey: "digitalCode",
                parameters: {},
                legalConvertedRange: [null, null],
                subChannel: 0,
            },
        ],
    },
};
